import { createLegacyCommunicationsModule } from '@izimi/modules';

import { communicationsApi } from '../di';

export const communicationsModule = createLegacyCommunicationsModule({ communicationsApi });
